import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 overflow-hidden px-6 lg:px-8 bg-[#F8F3FB]">
      {/* Decorative accent */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-1 bg-gradient-to-r from-transparent via-[#DBB6EE] to-transparent opacity-60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E9D9F2] mb-8">
          <i className="ri-sparkle-line text-[#4F2D63] text-sm"></i>
          <span className="text-[#4F2D63] text-xs font-semibold">For Qualified Applicants Only</span>
        </div>

        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight">
          {t('cta_title')}
        </h2>
        <p className="text-base text-gray-500 mb-10 max-w-xl mx-auto">
          {t('cta_subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-9 py-4 rounded-xl bg-[#4F2D63] hover:bg-[#3E234F] text-white font-semibold text-base transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
          >
            {t('cta_primary')}
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-9 py-4 rounded-xl border border-[#4F2D63] text-[#4F2D63] hover:bg-[#4F2D63] hover:text-white font-semibold text-base transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            {t('cta_secondary')}
          </Link>
        </div>

        <p className="text-xs text-gray-400">
          {t('cta_trust')}
        </p>

        {/* Trust icons */}
        <div className="flex flex-wrap justify-center gap-6 mt-8 pt-8 border-t border-[#E9D9F2]">
          {[
            { icon: 'ri-shield-check-line', text: 'Secure Application' },
            { icon: 'ri-lock-2-line', text: 'Privacy Protected' },
            { icon: 'ri-verified-badge-line', text: '15+ Years Trusted' },
            { icon: 'ri-global-line', text: 'EN / ES Support' },
          ].map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className={`${icon} text-[#0F766E] text-sm`}></i>
              </div>
              <span className="text-xs text-gray-500 whitespace-nowrap">{text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
